import React, { useState } from 'react';

const ItineraryDialog = ({  isOpen, onClose, data }) => {
    if (!isOpen) return null;

    return (
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white w-4/5 h-[85vh] rounded-lg shadow-lg overflow-hidden">
          <div className="flex justify-between items-center p-4 border-b  text-black ">
            <h2 className="text-2xl font-bold noto ml-[400px]">Itinerary</h2>
            <button
              onClick={onClose}
              className="text-2xl font-bold text-white hover:text-gray-300"
            >
              &times;
            </button>
          </div>
  
          <div className="p-4 overflow-y-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
            {data.map((day, index) => (
              <div key={index} className="bg-gray-100 rounded-lg shadow-md p-4">
                <img
                  src={day.image}
                  alt={`${day.day} illustration`}
                  className="w-full h-40 object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-bold text-gray-700 mb-2">{day.day}</h3>
                <p className="text-gray-600">{day.description}</p>
              </div>
            ))}
          </div>
  
          <div className="p-4 border-t text-right bg-gray-50">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
};

export default ItineraryDialog;